import { CreateCheckpointJSONDto } from './survey.dto';

export interface CheckpointDto {
  id: number;
  title: string;
  message: string;
  summary: string;
  isCompletionCheckpoint: boolean;
  dueDateOffsetDays: number;
  reminderBaseDateQuestionId: number;
}

export const DEFAULT_CHECKPOINT: CreateCheckpointJSONDto = {
  title: '',
  message: '',
  summary: '',
  isCompletionCheckpoint: false,
  dueDateOffsetDays: 0,
  reminderBaseDateQuestionKey: '',
  completionActionConfig: null,
};
